import { SignUp } from '@clerk/clerk-react'
import { useSearchParams } from 'react-router-dom'

import { AuthLayout } from '@/components/auth/AuthLayout'
import { peekAuthRedirect, safeRedirect, withRedirect } from '@/lib/redirect'

export function SignUpPage() {
  const [params] = useSearchParams()
  const fromParam = safeRedirect(params.get('redirect_url'))
  const target = fromParam === '/' ? (peekAuthRedirect() ?? '/') : fromParam

  return (
    <AuthLayout title="Join dizcant">
      <SignUp
        path="/sign-up"
        routing="path"
        signInUrl={withRedirect('/sign-in', target)}
        // New users get the one-question onboarding step, which then forwards
        // to `target` via the sessionStorage bridge.
        fallbackRedirectUrl="/welcome"
        forceRedirectUrl="/welcome"
      />
    </AuthLayout>
  )
}
